const globalConfig = {
  data() {
    return {
      config_HideOtherTargetGroups: false,
      config_WebApiUrl: "",
      config_JwtTokenExpiry: "",
      config_GoogleTagId: "",
      config_BackgroundColor: "",
      config_ApplicationHeading: "",
      config_ApplicationHeadingVideoInHome: "",
      config_ApplicationSubHeading: "",
      config_ApplicationSubHeadingVideoInHome: "",
      config_LinkOnlineAnalys: "",
      config_LinkTotalanalys: "",
      config_LinkDataPortal: "",
      config_MiniumClientVersion: "",
      config_CurrentClientVersion: "",
      config_AppCookieDomain: "",
      config_AppCookieDomainVideoInHome: "",
      config_AuthCookieDomain: "",
      config_AnalyzeRowsToRofLimit: "",
      config_WebCaatAuthWebUrl: "",
      config_ShowGroupByDropdowns: "",
      config_ShowStreamingTab: "",
      ShowVideoInHomeAsTabInTvAnalys: "",
      config_NumberOfTargetGroups: "",
      config_ShowChannelRadioButtons: "",
      config_ShowSaveSearchButton: "",
      config_ShowTargetDevices: "",
      config_LinkTvAnalys: "",
      config_LinkVideoInHome: ""
    };
  },
  methods: {
    async loadGlobalConfigFromFile() {
      try {
        await fetch("/config/runtime.json")
          .then(response => {
            return response.json();
          })
          .then(data => {
            this.config_HideOtherTargetGroups = data.HideOtherTargetGroups;
            this.config_WebApiUrl = data.WebApiUrl;
            this.config_JwtTokenExpiry = data.JwtTokenExpiry;
            this.config_GoogleTagId = data.GoogleTagId;
            this.config_BackgroundColor = data.BackgroundColor;
            this.config_ApplicationHeading = data.ApplicationHeading;
            this.config_ApplicationHeadingVideoInHome = data.ApplicationHeadingVideoInHome;
            this.config_ApplicationSubHeading = data.ApplicationSubHeading;
            this.config_ApplicationSubHeadingVideoInHome = data.ApplicationSubHeadingVideoInHome;
            this.config_LinkOnlineAnalys = data.LinkOnlineAnalys;
            this.config_LinkTotalanalys = data.LinkTotalanalys;
            this.config_LinkDataPortal = data.LinkDataPortal;
            this.config_MiniumClientVersion = data.MiniumClientVersion;
            this.config_CurrentClientVersion = data.CurrentClientVersion;
            this.config_AppCookieDomain = data.AppCookieDomain;
            this.config_AppCookieDomainVideoInHome = data.AppCookieDomainVideoInHome;
            this.config_AuthCookieDomain = data.AuthCookieDomain;
            this.config_AnalyzeRowsToRofLimit = data.AnalyzeRowsToRofLimit;
            this.config_WebCaatAuthWebUrl = data.WebCaatAuthWebUrl;
            this.config_ShowGroupByDropdowns = data.ShowGroupByDropdowns;
            this.config_ShowStreamingTab = data.ShowStreamingTab;
            this.config_ShowVideoInHomeAsTabInTvAnalys = data.ShowVideoInHomeAsTabInTvAnalys;
            this.config_NumberOfTargetGroups = data.NumberOfTargetGroups;
            this.config_ShowChannelRadioButtons = data.ShowChannelRadioButtons;
            this.config_ShowSaveSearchButton = data.ShowSaveSearchButton;
            this.config_ShowTargetDevices = data.ShowTargetDevices;
            this.config_LinkTvAnalys = data.LinkTvAnalys;
            this.config_LinkVideoInHome = data.LinkVideoInHome;
          })
          .catch(error => {
            console.error(error);
          });
      } catch (error) {
        console.error(error);
      }
    }
  }
};

export default globalConfig;
